export default "__VITE_ASSET__5$B5tJbU__"